import React from 'react'
import { string, number, bool } from 'prop-types'

import { Card, CardBlock } from 'components/qstrap'
import Markdown from 'components/atoms/MarkdownContent'

const NumberedListItem = ({ content, no, bordered }) => (
  <div className={`number-list-item ${!bordered ? 'number-list-item--no-border' : 'adas'}`}>
    <Card className="number-list-item__card">
      <CardBlock>
        <div className="number-list-item__content">
          <div className="number-list-item__no">
            <span>{no}</span>
          </div>
          <div className="number-list-item__text">
            <Markdown content={content} />
          </div>
        </div>
      </CardBlock>
    </Card>

    <style jsx>
      {`
        .number-list-item {
          margin-left: 8.333%;
          :global(&__card) {
            box-shadow: 0 4px 16px 0 rgba(30, 63, 107, 0.1);
          }
          &__no {
            height: 100%;
            display: flex;
            align-items: center;
            margin: 16px;
            span {
              width: 48px;
              height: 48px;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #0fc3c4;
              color: #fff;
              border-radius: 100%;
            }
          }
          &__content {
            display: flex;
            align-items: center;
            margin-left: -64px;
            @media screen and (max-width: 576px) {
              margin-left: 0 !important;
              flex-direction: column;
              margin-top: -56px;
            }
          }
          &__text {
            :global(p) {
              margin-bottom: 0;
            }
          }
          @media screen and (max-width: 576px) {
            margin-left: 0 !important;
            margin-top: 28px;
          }
        }
      `}
    </style>
  </div>
)

NumberedListItem.propTypes = {
  content: string,
  no: number,
  bordered: bool,
}

export default NumberedListItem
